import {configureStore} from '@reduxjs/toolkit'
import productReducer from '../slice/prductSlice'
export const store=configureStore({
    reducer:{
        data:productReducer
    }
})